module.exports = __webpack_public_path__ + "public/files/img/og-wa.5cd92699.png";